import { INTERPOLATION_PATTERN } from "./constants";
import type { TranslationValues } from "./types";

export function interpolateText(text: string, values: TranslationValues = {}): string {
  return text.replace(INTERPOLATION_PATTERN, (match, key: string) => {
    const value = values[key];

    if (typeof value === "string" || typeof value === "number") {
      return String(value);
    }

    return match;
  });
}
